import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Fetches all active price lists for the org. Used by the customer detail
 * dropdown (metadata.price_list_id) and the Order Management module config
 * (defaultPriceListId) — both rendered as a small static list, so no search
 * params or pagination.
 */
export function usePriceLists() {
  return useQuery(orpc.accountsReceivable.priceLists.list.queryOptions());
}
